/* TÖSTI UI: (1) billede nr. 2 ved hover på produktkort (lazy, kun mus, samme farvevariant), (2) cookie-popup udseende (kun visning, ingen logik ændres) */
(function(){
  'use strict';
  /* ---------- 1) HOVER-BILLEDE ---------- */
  var canHover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cache = {};
  function linkInfo(root){
    var a = root.querySelector('a[href*="/products/"]');
    if(!a) return null;
    var href = a.getAttribute('href') || '';
    var m = /\/products\/([^\/?#]+)/.exec(href);
    if(!m) return null;
    var v = /[?&]variant=(\d+)/.exec(href);
    return {handle: m[1], variant: v ? v[1] : null};
  }
  function product(handle){
    if(!cache[handle]){
      cache[handle] = fetch('/products/' + handle + '.js', {credentials:'same-origin'})
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }
    return cache[handle];
  }
  /* Billede nr. 2 i SAMME farve: billedet lige efter varianten's eget hovedbillede */
  function pick(p, variantId, primarySrc){
    if(!p || !p.images || p.images.length < 2) return null;
    var imgs = p.images, idx = 0;
    var v = null, i;
    if(variantId){ for(i = 0; i < p.variants.length; i++){ if(String(p.variants[i].id) === variantId){ v = p.variants[i]; break; } } }
    if(!v) v = p.variants[0];
    if(v && v.featured_image && v.featured_image.position) idx = v.featured_image.position - 1;
    var next = imgs[idx + 1] || imgs[idx - 1] || null;
    if(!next) return null;
    var base = function(u){ return String(u).split('?')[0]; };
    if(primarySrc && base(next) === base(primarySrc)) next = imgs[idx + 2] || null;
    return next;
  }
  function sized(url){ return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=680'; }
  function attach(wrap){
    if(wrap.__tosti2) return;
    wrap.__tosti2 = 1;
    var primary = wrap.querySelector('img.product-item-image, img');
    if(!primary) return;
    if(wrap.querySelector('img.product-item-image--secondary')) return;
    var info = linkInfo(wrap.closest('.product-item, article') || wrap);
    if(!info) return;
    product(info.handle).then(function(p){
      var url = pick(p, info.variant, primary.currentSrc || primary.src);
      if(!url) return; /* kun ét billede: ingenting sker */
      var host = primary.parentElement;
      var cs = getComputedStyle(host);
      if(cs.position === 'static') host.style.position = 'relative';
      if(cs.display === 'inline') host.style.display = 'block';
      var img = document.createElement('img');
      img.className = 'product-item-image--secondary tosti-hover-img';
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.decoding = 'async';
      img.onload = function(){ img.classList.add('is-ready'); };
      img.src = sized(url);
      host.appendChild(img);
    });
  }
  function onOver(e){
    var wrap = e.target.closest && e.target.closest('.product-item__image-wrapper, .tosti-card-img');
    if(wrap) attach(wrap);
  }
  if(canHover) document.addEventListener('mouseover', onOver, {passive:true});

  /* ---------- 2) COOKIE-POPUP (Consentmo, shadow DOM) ---------- */
  var BROWN = '#2f231b', SAND = '#F7F2E3';
  function blurOK(){ try{ return window.CSS.supports('backdrop-filter','blur(1px)') || window.CSS.supports('-webkit-backdrop-filter','blur(1px)'); }catch(e){ return false; } }
  var HOSTCSS = ':host{position:fixed !important;inset:0 !important;width:100vw !important;height:100vh !important;display:flex !important;align-items:center !important;justify-content:center !important;pointer-events:auto !important;overflow:auto !important;z-index:2147483000 !important;' +
    (blurOK() ? 'background:rgba(255,255,255,0.45) !important;-webkit-backdrop-filter:blur(3px) !important;backdrop-filter:blur(3px) !important;' : 'background:rgba(255,255,255,0.85) !important;') + '}';
  var BARCSS =
  '#csm-wrapper,#csm-wrapper > *{box-sizing:border-box}' +
  '.csm-wrapper{position:static !important;width:100% !important;display:flex !important;justify-content:center !important;align-items:center !important;min-height:0 !important;background:transparent !important}' +
  '.csm-cmp-bar{position:static !important;inset:auto !important;transform:none !important;width:100% !important;max-width:480px !important;margin:0 auto !important;background:transparent !important;background-color:transparent !important;box-shadow:none !important;border:0 !important;padding:24px !important;color:'+BROWN+' !important;text-align:center !important;font-family:var(--tosti-font-body,Archivo,Helvetica,Arial,sans-serif) !important}' +
  '.csm-cmp-bar *{color:'+BROWN+' !important;text-align:center !important}' +
  '.csm-cmp-body{display:flex !important;flex-direction:column !important;align-items:stretch !important;gap:20px !important;padding:0 !important;margin:0 !important}' +
  '.csm-cmp-bar p,.csm-cmp-bar .cc-message{font-size:15px !important;line-height:1.6 !important;font-weight:400 !important;margin:0 !important}' +
  '.csm-cmp-bar a.cc-link{text-decoration:underline !important;text-underline-offset:3px}' +
  '.csm-cmp-bar .cc-compliance{display:flex !important;flex-direction:column !important;align-items:stretch !important;gap:12px !important;width:100% !important;flex:1 1 auto !important;margin:0 !important}' +
  '.csm-cmp-bar .cc-btn{display:flex !important;align-items:center !important;justify-content:center !important;width:100% !important;min-height:44px !important;margin:0 !important;border-radius:2px !important;font-family:var(--tosti-font-ui,"Archivo Narrow",Arial,sans-serif) !important;font-weight:600 !important;font-size:14px !important;letter-spacing:.18em !important;text-transform:uppercase !important;cursor:pointer;box-shadow:none !important}' +
  '.csm-cmp-bar .cc-allow{order:1;background:'+BROWN+' !important;background-color:'+BROWN+' !important;border:1.5px solid '+BROWN+' !important}' +
  '.csm-cmp-bar .cc-allow,.csm-cmp-bar .cc-allow *{color:'+SAND+' !important}' +
  '.csm-cmp-bar .cc-deny{order:2;background:transparent !important;background-color:transparent !important;border:1.5px solid '+BROWN+' !important}' +
  '.csm-cmp-bar .cc-settings{order:3;background:transparent !important;background-color:transparent !important;border:0 !important;min-height:44px !important;text-decoration:underline !important;text-underline-offset:3px;font-weight:500 !important;letter-spacing:.12em !important}' +
  '.csm-cmp-bar .cc-allow:hover,.csm-cmp-bar .cc-deny:hover,.csm-cmp-bar .cc-settings:hover{opacity:.5}' +
  '@media (max-width:767px){.csm-cmp-bar{width:90% !important;padding:24px !important}.csm-cmp-bar .cc-btn{letter-spacing:.10em !important}}';

  var barSheet = null, hostSheet = null, canAdopt = !!(window.CSSStyleSheet && 'replaceSync' in CSSStyleSheet.prototype);
  if(canAdopt){ try{ barSheet = new CSSStyleSheet(); barSheet.replaceSync(BARCSS); hostSheet = new CSSStyleSheet(); hostSheet.replaceSync(HOSTCSS); }catch(e){ canAdopt = false; } }

  function lock(on){
    var de = document.documentElement;
    if(on){ de.style.setProperty('overflow','hidden','important'); if(document.body) document.body.style.setProperty('overflow','hidden','important'); }
    else { de.style.removeProperty('overflow'); if(document.body) document.body.style.removeProperty('overflow'); }
  }
  function barVisible(sr){
    var bar = sr.querySelector('.csm-cmp-bar');
    if(!bar) return null;
    var cs = getComputedStyle(bar);
    if(cs.display === 'none' || cs.visibility === 'hidden') return null;
    return bar;
  }
  function setSheets(sr, withHost){
    var keep = Array.prototype.filter.call(sr.adoptedStyleSheets || [], function(s){ return s !== barSheet && s !== hostSheet; });
    var list = keep.concat([barSheet]);
    if(withHost) list.push(hostSheet);
    var cur = sr.adoptedStyleSheets || [];
    var same = cur.length === list.length && list.every(function(s, i){ return cur[i] === s; });
    if(!same) sr.adoptedStyleSheets = list;
  }
  function inl(el, prop, val){ if(el && (el.style.getPropertyValue(prop) !== val || el.style.getPropertyPriority(prop) !== 'important')) el.style.setProperty(prop, val, 'important'); }
  function layerOn(host, sr, bar){
    if(canAdopt){ setSheets(sr, true); }
    else {
      if(!sr.querySelector('style[data-tosti-bar]')){ var st = document.createElement('style'); st.setAttribute('data-tosti-bar','1'); st.textContent = BARCSS + HOSTCSS; sr.appendChild(st); }
    }
    var allow = bar.querySelector('.cc-allow'), deny = bar.querySelector('.cc-deny'), set = bar.querySelector('.cc-settings');
    if(allow){ inl(allow,'background-color',BROWN); inl(allow,'color',SAND); inl(allow,'border-color',BROWN); var t = allow.querySelector('.csm-arp-btn-text'); if(t) inl(t,'color',SAND); }
    if(deny){ inl(deny,'background-color','transparent'); inl(deny,'color',BROWN); inl(deny,'border-color',BROWN); var t2 = deny.querySelector('.csm-arp-btn-text'); if(t2) inl(t2,'color',BROWN); }
    if(set){ inl(set,'background-color','transparent'); inl(set,'color',BROWN); inl(set,'border-color','transparent'); }
    inl(bar,'background-color','transparent'); inl(bar,'box-shadow','none');
    var s = host.style;
    inl(host,'pointer-events','auto');
    if(!host.__tostiFade){
      host.__tostiFade = 1;
      s.setProperty('opacity','0','important');
      s.setProperty('transition','opacity 200ms ease','important');
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ s.setProperty('opacity','1','important'); }); });
    }
    if(!sr.__tostiClick){
      sr.__tostiClick = 1;
      sr.addEventListener('click', function(ev){
        var b = ev.target.closest && ev.target.closest('.cc-allow,.cc-deny');
        if(b) host.style.setProperty('opacity','0','important');
      }, true);
    }
  }
  function layerOff(host, sr){
    if(canAdopt) setSheets(sr, false);
    else { var st = sr.querySelector('style[data-tosti-bar]'); if(st) st.remove(); }
    if(host.__tostiFade){ host.style.removeProperty('opacity'); host.style.removeProperty('transition'); host.__tostiFade = 0; }
  }
  var locked = false;
  function tick(){
    var host = document.querySelector('csm-cookie-consent');
    var sr = host && host.shadowRoot;
    var bar = sr && barVisible(sr);
    if(bar){
      layerOn(host, sr, bar);
      if(!locked){ lock(true); locked = true; }
    } else {
      if(sr) layerOff(host, sr);
      if(locked){ lock(false); locked = false; }
    }
  }
  var n = 0, iv = setInterval(function(){ tick(); if(++n > 2400) clearInterval(iv); }, 250);
  document.addEventListener('DOMContentLoaded', tick);
})();
